"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableComponent = void 0;
/* eslint-disable no-param-reassign */
const AppError_1 = require("../../../errors/AppError");
var TableComponent;
(function (TableComponent) {
    TableComponent.type = 'table';
    TableComponent.minCellWidth = 4;
    // firebase does not support multidimensional arrays, so the data in firebase is serialized
    function tableDataToArray(tableData) {
        if (typeof tableData === 'string') {
            const data = JSON.parse(tableData);
            if (!Array.isArray(data))
                throw new AppError_1.AppError('unexpected-data', 'JSON should contain a array');
            return JSON.parse(tableData);
        }
        return tableData;
    }
    TableComponent.tableDataToArray = tableDataToArray;
    function createTableData(rowCount, columnCount) {
        const tableData = Array(rowCount).fill(Array(columnCount).fill({
            content: '',
        }));
        return tableData;
    }
    TableComponent.createTableData = createTableData;
    function updateTableData(tableData, pasteData, cellIndex) {
        let hasReplacedContent = false;
        const data = tableData.map((row, currentRow) => {
            const rowInPasteData = pasteData[currentRow - cellIndex.row];
            const isCurrentRowTarget = currentRow >= cellIndex.row;
            if (isCurrentRowTarget && rowInPasteData) {
                return row.map((cell, currentCell) => {
                    const pasteContent = rowInPasteData[currentCell - cellIndex.col];
                    const isCurrentCellTarget = currentCell >= cellIndex.col;
                    if (isCurrentCellTarget && pasteContent) {
                        if (cell.content !== '' && pasteContent !== '')
                            hasReplacedContent = true;
                        return { ...cell, content: pasteContent };
                    }
                    return { ...cell };
                });
            }
            return [...row];
        });
        return { data, hasReplacedContent };
    }
    TableComponent.updateTableData = updateTableData;
    function getCell(tableData, row, col) {
        if (tableData[row] && tableData[row][col])
            return tableData[row][col];
        return undefined;
    }
    TableComponent.getCell = getCell;
    function createRowData(rowAmount) {
        return Array(rowAmount).fill({ header: false, height: 10 });
    }
    TableComponent.createRowData = createRowData;
    function heightPercentToEm(height) {
        return height / 10 + 'em';
    }
    TableComponent.heightPercentToEm = heightPercentToEm;
    const defaultAlignment = 'align-left';
    function createColumnData(colAmount) {
        return Array(colAmount).fill({
            header: false,
            alignment: defaultAlignment,
            width: 100 / colAmount,
        });
    }
    TableComponent.createColumnData = createColumnData;
    function getHeaders(settings) {
        const lastRow = settings.rows.length - 1;
        const lastColumn = settings.columns.length - 1;
        const headers = {
            top: !!settings.rows[0].header,
            bottom: !!settings.rows[lastRow].header && lastRow !== 0,
            left: !!settings.columns[0].header,
            right: !!settings.columns[lastColumn].header && lastColumn !== 0,
        };
        return headers;
    }
    TableComponent.getHeaders = getHeaders;
    function setRowHeaders(headers, rows) {
        const lastRow = rows.length - 1;
        return rows.map((row, i) => {
            if ((i === 0 && headers.top) || (i === lastRow && headers.bottom))
                return { ...row, header: true };
            return { ...row, header: false };
        });
    }
    TableComponent.setRowHeaders = setRowHeaders;
    function setColumnHeaders(headers, columns) {
        const lastColumn = columns.length - 1;
        return columns.map((column, i) => {
            if ((i === 0 && headers.left) || (i === lastColumn && headers.right))
                return { ...column, header: true };
            return { ...column, header: false };
        });
    }
    TableComponent.setColumnHeaders = setColumnHeaders;
    function allContent(tableData) {
        return tableDataToArray(tableData)
            .reduce((acc, row) => {
            return acc.concat(row.map((cell) => cell.content));
        }, [])
            .join(' ');
    }
    TableComponent.allContent = allContent;
    TableComponent.fillColors = [
        'none',
        'white',
        'grey-bg',
        'brown-dark',
        'yellow',
        'pink',
        'blue',
        'green',
        'orange',
        'cyan',
    ];
    TableComponent.cellClassName = 'ct-cell';
})(TableComponent || (exports.TableComponent = TableComponent = {}));
//# sourceMappingURL=TableComponent.js.map